module.exports = __webpack_public_path__ + "img/10-2.fb10ae58.png";